import { JSX } from "react";
import Skeleton from "react-loading-skeleton";
import { CardWrapper } from "@hatch-digital-nl/bravilor-storybook";
import { useProductGeneralInformation } from "../../hooks/productDetail/useProductGeneralInformation";
import { LanguageInterface } from "../../interfaces/shared/LanguageInterface";
import { ProductDetailInterface } from "../../interfaces/apiV2/product/ProductDetailInterface";

interface Props {
    data?: ProductDetailInterface;
    activeLanguage: LanguageInterface | null;
    loading: boolean;
}

export const ProductGeneralInformation = ({
    data,
    activeLanguage,
    loading,
}: Props): JSX.Element | null => {
    const { showSkeleton, hasContent, cardTitle, descriptionHtml } =
        useProductGeneralInformation({ data, activeLanguage, loading });

    if (showSkeleton) {
        return (
            <CardWrapper isLoading>
                <div>
                    <Skeleton height="3rem" width="95%" borderRadius="0.8rem" />
                    <Skeleton height="3rem" width="80%" borderRadius="0.8rem" />
                </div>
            </CardWrapper>
        );
    }

    if (!hasContent || !descriptionHtml) {
        return null;
    }

    return (
        <CardWrapper title={cardTitle}>
            <div className="c-product-general-info">
                <div dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
            </div>
        </CardWrapper>
    );
};
